// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"6270c0c5","568":"55911c8c"}[chunkId] + ".chunk.js";
};